import React from 'react'
import foto from '../../Asist/img/girl.png'
import './SectionSeven.css'
export default function SectionSeven() {
    return (
        <section id='six' className='seven'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <h1>Есть вопрос?</h1>
                        <h2>Связаться с нами</h2>
                        <form action="">
                            <input type="text" placeholder='Имя' />
                            <input type="text" placeholder='Телефонный номер' />
                            <input type="email" placeholder='Электронная почта' />
                            <input type="text" placeholder='Тема' />
                        </form>
                        <p><input type="checkbox" />Даю согласие на обработку персональных данных *</p>
                        <button>Отправить сообщение</button>
                    </div>
                    <div className="col-lg-6">
                        <img src={foto} alt="" />
                    </div>
                </div>
            </div>
        </section>
    )
}
